import Box from '@mui/material/Box';
import { useRecoilValue } from 'recoil';
import { currentStructureSetState } from '~/state/atoms/structureSet/structureSetAtoms';
import { StructureSetSettings } from '../StructureSet/StructureSetDetails/StructureSetSettings';
import DisplayStructuresToggle from './actions/DisplayStructuresToggle';
import StructuresActionMenu from './actions/StructuresActionMenu';

export default function StructureSetHeader() {
    const currentStructureSet = useRecoilValue(currentStructureSetState);
    return (
        <Box display="flex" justifyContent="space-between" position="relative">
            {currentStructureSet && (
                <Box display="flex" gap={0.5} alignItems="center" mr={-0.5}>
                    <StructureSetSettings />
                    <DisplayStructuresToggle />
                    <StructuresActionMenu
                        currentStructureSet={currentStructureSet}
                    />
                </Box>
            )}
        </Box>
    );
}
